import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AuthResponse } from '../auth/auth.service';
import { CertificateCallbackComponent } from '../auth/certificate-callback.component';
import { GuardAuthComponent } from '../auth/guard-auth.component';
import { IrrigatorAuthComponent } from '../auth/irrigator-auth.component';
import { ManagerAuthComponent } from '../auth/manager-auth.component';
import { ProfileSelectionComponent } from '../auth/profile-selection.component';
import { SiteFooterComponent } from '../site-footer/site-footer.component';
import { LoginOption, ProfileKey } from '../visor.types';

@Component({
  selector: 'app-auth-shell',
  imports: [
    CertificateCallbackComponent,
    GuardAuthComponent,
    IrrigatorAuthComponent,
    ManagerAuthComponent,
    ProfileSelectionComponent,
    SiteFooterComponent
  ],
  templateUrl: './auth-shell.component.html',
  styleUrl: './auth-shell.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AuthShellComponent {
  @Input() showCertificateCallback = false;
  @Input() showIrrigatorAuth = false;
  @Input() showGuardAuth = false;
  @Input() showManagerAuth = false;
  @Input() certificateCallbackError = '';
  @Input() certificateCallbackLoading = false;
  @Input({ required: true }) loginOptions: LoginOption[] = [];
  @Input({ required: true }) profileIconPaths: Record<ProfileKey, string> = {
    public: '',
    irrigators: '',
    guards: '',
    managers: ''
  };

  @Output() certificateBackRequested = new EventEmitter<void>();
  @Output() profileSelected = new EventEmitter<LoginOption>();
  @Output() authenticated = new EventEmitter<AuthResponse>();
  @Output() backToProfileSelectionRequested = new EventEmitter<void>();
}
